export default __webpack_public_path__ + "static/1575-70127d008391e7a9e240355aac67629b.gif";